<template>
  <QPaginatedSearchDropdown :value="value" :list-getter="getList" :filter="filter" :min-search-char-limit="0"
    :externaledit="externaledit" :clearable="clearable" :multiple="multiple" :returnobject="returnobject"
    :disabled="disabled" :loading="loading" valuekey="Id" textkey="Name" :singleline="singleline"
    :label="label ? label : $t('servicesystem.common_objects.user.employment')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.user.employment')"
    @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$employment</v-icon>
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "EmploymentSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    hideIcon: Boolean,
    singleline: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async getList(filtersAndPagination) {
      var list = await clientAPI.methods.getEmploymentList();
      var query = filtersAndPagination.SearchWord;
      if (query) {
        list = list.filter((item) => (item.Name.toUpperCase()).includes(query.toUpperCase()));
      }
      //console.log(query, list.length);
      return list;
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>